import { render, staticRenderFns } from "./CoverWebForm.vue?vue&type=template&id=33aa9860&"
import script from "./CoverWebForm.vue?vue&type=script&lang=js&"
export * from "./CoverWebForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports